import { BehaviorSubject } from "rxjs";
import { HandleResponse } from "../_helpers";
import configData from "../../config.json";
import $ from "jquery";

const currentUserSubject = new BehaviorSubject(
  JSON.parse(localStorage.getItem("currentUser"))
);

export const AuthenticationService = {
  login,
  reset,
  logout,
  refreshToken,
  currentUser: currentUserSubject.asObservable(),
  get currentUserValue() {
    return currentUserSubject.value;
  },
};

function login(username, password) {
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ username, password }),
  };

  return fetch(configData.BO_API + 'Auth/Login', requestOptions)
    .then(HandleResponse)
    .then((user) => {
      // store user details and jwt token in local storage to keep user logged in between page refreshes
      localStorage.setItem("currentUser", JSON.stringify(user));
      currentUserSubject.next(user);

      return user;
    });
}

function reset(email) {  

  $.ajax({
    type: 'POST',            
    async: false,            
    url: configData.BO_API + 'Auth/Reset',    
    data: JSON.stringify({email}),
    contentType:"application/json; charset=utf-8",
    dataType:"json",
    success: function(data) {     
      
        
    },
    error: function(data) {       
        console.log(data);                                      
    },
    complete: function(data) {
      // remove user from local storage to log user out  
      localStorage.removeItem("currentUser");
      currentUserSubject.next(null);
      return true;                                             
    }
  });
}

async function refreshToken(refreshToken){
  var currentUser = JSON.parse(localStorage.getItem("currentUser"));
  if(currentUser){
    currentUser.APIToken = refreshToken;
    await localStorage.setItem("currentUser", JSON.stringify(currentUser));
    return true;
  }
}

function logout() {
  // remove user from local storage to log user out  

  var currentUser = JSON.parse(localStorage.getItem("currentUser"));

  $.ajax({
    type: 'POST',            
    async: true,
    url: configData.BO_API + 'Auth/Logout',
    headers: {'Authorization': 'Bearer ' + currentUser.APIToken},
    success: function(data) {    
      if(data.status==401)
      {
        AuthenticationService.logout().then(window.location.href ="/authentication/timeout/" );
      }                                             
    },
    error: function(data) {       
        console.log(data);                              
    }    
  })

localStorage.removeItem("currentUser");
currentUserSubject.next(null);

return true;

  
  
}
